import { IInfoBannerProps } from "./InfoBanner.interface";
import Link from "../../Link/Link";
import { useCallback, useContext, useState } from "react";
import { ModuleContext } from "../../../shared/providers/module/module.provider";
import { TranslationContext } from "../../../shared/providers/translation/translation.provider";
import { ComponentTypes } from "../../../shared/interfaces/modules.interface";
import { useIntersectionObserver } from "../../../shared/hooks/useIntersectionObserver";

function InfoBanner(props: IInfoBannerProps) {
    const { unitId, id } = props;
    const { progress, setProgress } = useContext(ModuleContext);
    const { lang } = useContext(TranslationContext);
    const [isCompleted, setIsCompleted] = useState<boolean>(false);

    const checkProgress = useCallback(
        (entry: any) => {
            const isItemId = props.id === progress?.itemId && props.type === progress?.itemType;

            if (entry.isIntersecting && !isItemId && !isCompleted) {
                handleProgress();
            }
        },
        [progress, props, isCompleted]
    );
    const { ref } = useIntersectionObserver(checkProgress);

    const handleProgress = useCallback(() => {
        if (lang && unitId) {
            setProgress({
                unitId: unitId,
                itemId: id,
                progress: 100,
                itemType: ComponentTypes.INFO_BANNER,
                itemLocale: lang
            });
            setIsCompleted(true);
        }
    }, [lang, unitId]);

    return (
        <section
            ref={ref}
            className="unit_item no_margins container-fluid gx-2 bg-green-100 px-1 py-2">
            <div className="row gx-0">
                <div className="col-12">
                    <h2 className="text-h4-bd mb-02">{props.title}</h2>
                    <p className="text-bd2-rg color-neutrals-dark">{props.description}</p>

                    {props.link && (
                        <Link
                            target={props.link.target ?? ""}
                            to={props.link.href}
                            variant="link"
                            customCss="justify-content-start"
                            icon={props.icon}
                            hasChevron>
                            {props.link.text}
                        </Link>
                    )}
                </div>
            </div>
        </section>
    );
}

export default InfoBanner;
